import React, { useEffect, useState } from 'react'
import { HoraActual, fechaActual } from '../../../hooks/UseDate'
import { postHorarioQuirofanos, postInsertQuirofanos, postVerificarQuirofanoOcupado, updateReprogramarCirugia } from '../../../services/PaginaRuta';
import ModalQuirofanosReprogramar from '../reprogramarCirugia/ModalQuirofanosReprogramar';
import ModalValidarQuirofanosReprogramacion from '../reprogramarCirugia/ModalValidarQuirofanosReprogramacion';

const CambioDeEstadoReProgramacion = ({user,setmodalOnCambioEstadoReprogramado,passDataActualizaTablaPacientes}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [errorMotivoReprogramacion,seterrorMotivoReprogramacion]=useState('Por favor elija un motivo de reprogramación válido')
    const [textAreaMotivo, settextAreaMotivo]=useState('')
    const [validarHoraInicial, setvalidarHoraInicial]=useState('')
    const [validarHoraFinal, setvalidarHoraFinal]=useState('')
    const [validarFecha, setvalidarFecha]=useState('')
    const [modalOnQuirofanos, setmodalOnQuirofanos]=useState(false)
    const [modalOnOcupadoQuirofano, setmodalOnOcupadoQuirofano]=useState(false)
    const [textQuirofanoOcupado, settextQuirofanoOcupado]=useState('')
    const [horaI, sethoraI]=useState('')
    const [horaF, sethoraF]=useState('')
    const [dataQuirofano, setdataQuirofano]=useState({
      codigoQuirofano:user.ProCons,
      descripcionQuirofano: user.ConsDet,   
    })
    const handleCancelarClick=()=>{
      setmodalOnCambioEstadoReprogramado(false)
    }

    function isDateTimeRangeOverlapping(userStartDateTime, userEndDateTime, existingStartDateTime, existingEndDateTime) {
      // Convertir las cadenas de fecha y hora a objetos Date
      let userStart = new Date(userStartDateTime);
      let userEnd = new Date(userEndDateTime);
      const existingStart = new Date(existingStartDateTime);
      const existingEnd = new Date(existingEndDateTime);
    
      // Restar un minuto (60,000 milisegundos) a userStart y userEnd
      userStart = new Date(userStart.getTime() + 60000);
      userEnd = new Date(userEnd.getTime() - 60000);
    
      // Calcular el punto medio del intervalo del usuario
      const userMidTime = new Date((userStart.getTime() + userEnd.getTime()) / 2);
    
      // Verificar si el punto medio del intervalo del usuario cae dentro del intervalo existente
      if (userMidTime >= existingStart && userMidTime <= existingEnd) {
        return true;
      }
    
      // Verificar si algún otro punto del intervalo del usuario se solapa con el intervalo existente
      if ((userStart >= existingStart && userStart <= existingEnd) ||
          (userEnd >= existingStart && userEnd <= existingEnd) ||
          (existingStart >= userStart && existingStart <= userEnd) ||
          (existingEnd >= userStart && existingEnd <= userEnd)) {
        return true;
      }
    
      // Si ninguna condición se cumple, entonces no hay solapamiento
      return false;
    }

    

    const handleSubmitReprogramacion=(e)=>{
      e.preventDefault()
      const reprogramar={       
        "ProCirCod":user.ProCirCod,
        "ProFec":e.target.fechaCirugia.value + ' 00:00:00',
        "ProFecF":e.target.fechaCirugia.value + ' 00:00:00',
        "ProHorI":e.target.horaInicial.value,
        "ProHorF":e.target.horaFinal.value,
        "ProEsta":"8",
        "ProMtCnTp":e.target.idMotivo.value,
        "ProMotCan":e.target.stringMotivo.value,
        "PPerCan": usuarioInfo.UsuarioEncriptado,
        "PROREGUSU":usuarioInfo.UsuarioEncriptado,
        "PROREGFEC":fechaActual() + ' 00:00:00', 
        "ProEmpCod":usuarioInfo.Empresa,
        "ProMCDpto":usuarioInfo.Sede,
        "ProCons": dataQuirofano.codigoQuirofano
        }
        if(validarFecha === '' && validarHoraFinal === '' && validarHoraInicial === '' && errorMotivoReprogramacion === ''){
          //validar si el quirofano esta ocupado con un paciente que tenga un procedimiento qx
          const validarQuirofano={
            ProEmpCod:usuarioInfo.Empresa            ,
            ProMCDpto:usuarioInfo.Sede,
            ProEsta:'3',
            ProFec:e.target.fechaCirugia.value,
            ProFecF:e.target.fechaCirugia.value,
            ProCons: dataQuirofano.codigoQuirofano,
            ProSedQr:usuarioInfo.Sede
          }

          postVerificarQuirofanoOcupado(validarQuirofano).then((res)=>{
            //let inputFechaInicial = new Date(`${e.target.fechaCirugia.value} ${e.target.horaInicial.value}:00`).getTime();
            let inputFechaInicial = `${e.target.fechaCirugia.value} ${e.target.horaInicial.value}`
            //inputFechaInicial = inputFechaInicial - 360000
            //let inputFechaFinal = new Date(`${e.target.fechaCirugia.value} ${e.target.horaFinal.value}:00`).getTime();
            let inputFechaFinal = `${e.target.fechaCirugia.value} ${e.target.horaFinal.value}`
            //inputFechaFinal = inputFechaFinal - 360000

            let quirofanoOcupados= res.data.find((validar)=>{
                
              if(parseInt(validar.ProCirCod) !== parseInt(user.ProCirCod)){                  
                  //let quirofanoFechaInicial = new Date(`${validar.ProFec.split(' ')[0]} ${validar.ProHorI}`).getTime();
                  //let quirofanoFechaFinal = new Date(`${validar.ProFecF.split(' ')[0]} ${validar.ProHorF}`).getTime();
                  let quirofanoFechaInicial = `${validar.ProFec.split(' ')[0]} ${validar.ProHorI}`
                  let quirofanoFechaFinal = `${validar.ProFecF.split(' ')[0]} ${validar.ProHorF}`
                  //return Math.min(inputFechaInicial, inputFechaFinal) <= Math.max(quirofanoFechaInicial, quirofanoFechaFinal) && Math.max(inputFechaInicial, inputFechaFinal) >= Math.min(quirofanoFechaInicial, quirofanoFechaFinal)           
                  return isDateTimeRangeOverlapping(inputFechaInicial,inputFechaFinal,quirofanoFechaInicial,quirofanoFechaFinal)
              }
              
             })

             if(quirofanoOcupados){
              //console.log(quirofanoOcupados,'quirofanoOcupados')
              settextQuirofanoOcupado(`El quirófano esta ocupado para el rango de fecha digitado ${e.target.fechaCirugia.value} hora inicial ${quirofanoOcupados.ProHorI} y hora final ${quirofanoOcupados.ProHorF} con la cirugia ${quirofanoOcupados.ProCirCod}`)
              setmodalOnOcupadoQuirofano(true)
             }else{

              //validar si el quirofano esta cerrado
              let inputFechaInicial = new Date(`${e.target.fechaCirugia.value} ${e.target.horaInicial.value}:00`)
              const validarHorarioQuirofano={
                ConsCod: dataQuirofano.codigoQuirofano,
                ConsDia:inputFechaInicial.getDay()+1
                }
                //console.log(validarHorarioQuirofano,'antes ocu')
                postHorarioQuirofanos(validarHorarioQuirofano).then((res)=>{
                  console.log(res.data,'ocupado si o no')
                  let inputFechaInicial = new Date(`${e.target.fechaCirugia.value} ${e.target.horaInicial.value}:00`).getTime();
                  inputFechaInicial = inputFechaInicial + 60000
                  let inputFechaFinal = new Date(`${e.target.fechaCirugia.value} ${e.target.horaFinal.value}:00`).getTime();
                  inputFechaFinal = inputFechaFinal - 60000

                  let quirofanoOcupados= false
                //   res.data.find((validar)=>{
                
                //     let quirofanoFechaInicial = new Date(`${e.target.fechaCirugia.value} ${validar.CoHEntQui}`).getTime();
                //     let quirofanoFechaFinal = new Date(`${e.target.fechaCirugia.value} ${validar.CoHSalQui}`).getTime();
                    
                //     return   quirofanoFechaInicial <= inputFechaInicial  && inputFechaFinal >= quirofanoFechaFinal  ||      quirofanoFechaInicial >= inputFechaInicial  && inputFechaFinal <= quirofanoFechaFinal 
                // })
                //console.log(quirofanoOcupados,'quirofanoOcupados')
                if(quirofanoOcupados){
                  settextQuirofanoOcupado('El quirofano no esta disponible')
                  setmodalOnOcupadoQuirofano(true)
                }else{
                  //modificar hora y fecha de la cirugia
                  updateReprogramarCirugia(reprogramar).then((res)=>{
                    //console.log(res.data,'update reprogramar')
                    setmodalOnCambioEstadoReprogramado(false)
                    passDataActualizaTablaPacientes(reprogramar)
                    //turqui////////
                    const insertQuirofanos={
                      "EMPCOD":usuarioInfo.Empresa,
                      "MCDpto":usuarioInfo.Sede,
                      "DOCCOD":"RTQ",
                      "ProCirCod":user.ProCirCod,
                      "TuQMedRes": user.ProPerSep,
                      "TuQUsrRes":  usuarioInfo.UsuarioEncriptado,
                      "TuQNroAut": "                    ",
                      "TuQEstTur": "C",
                      "TuQObs": "",
                      "TuQTpAnst": " ",
                      "TuInsCod": "0",
                      "TuInsXML": "",
                      "TuQFchSal": e.target.fechaCirugia.value + ' 00:00:00',
                      "TuQFchIng": e.target.fechaCirugia.value + ' 00:00:00',
                      "TuQHorIng": e.target.horaInicial.value,
                      "TuQHorSal": e.target.horaFinal.value,
                      "TuQCodCto": user.ProEPS,
                      "ConsCod": dataQuirofano.codigoQuirofano
                    }
                    postInsertQuirofanos(insertQuirofanos).then((res)=>{
                      console.log(res.data,'quirofanos')
                    }).catch((error) => {
                      console.error('Error al autenticar al usuario:', error);
                      //seterrorEndpoint(true);
                      
                    });
                    ///fin turqui
                  })
                }
                })

             }

          })
          
          
          
          
        }
        
    }

    const handleOnchange=(e)=>{
        //console.log(e.target.value)
        
       
        if(e.target.value === "Sin Motivo"){
          seterrorMotivoReprogramacion('Por favor elija un motivo de reprogramación válido')
          settextAreaMotivo('')
        }else if(e.target.value === "1"){
          seterrorMotivoReprogramacion('')
          settextAreaMotivo('EL MOTIVO DE LA REPROGRAMACION FUÉ DE TIPO ADMINISTRATIVO')
        }else if(e.target.value === "2"){
          seterrorMotivoReprogramacion('')
          settextAreaMotivo('  EL MOTIVO DE LA REPROGRAMACION FUÉ DE TIPO PACIENTE')
        }else if(e.target.value === "3"){
          seterrorMotivoReprogramacion('')
          settextAreaMotivo('  EL MOTIVO DE LA REPROGRAMACION FUÉ DE TIPO MÉDICO')
        }
      }

      useEffect(()=>{
        console.log(user,'userrr')
        setvalidarHoraInicial('Seleccionar Hora Inicial')
        setvalidarHoraFinal('Seleccionar Hora Final')
        setvalidarFecha('Seleccionar Fecha')
      },[])

      const handleOnchangeHoraInicial=(e)=>{
        sethoraI(e.target.value)
        if(e.target.value === ""){
          setvalidarHoraInicial('Seleccionar Hora Inicial')          
        }else if(e.target.value === horaF){
          setvalidarHoraFinal('Hora inicial y Hora final no pueden ser iguales')
          setvalidarHoraInicial('Hora inicial y Hora final no pueden ser iguales')
        }else if(e.target.value > horaF){
          setvalidarHoraInicial('Hora Inicial no puede ser mayor a la hora Final')
          setvalidarHoraFinal('')
        }else if(horaF < e.target.value){
          setvalidarHoraFinal('Hora Final no puede ser menor a la hora Inicial')
          setvalidarHoraInicial('')
        }
        else{
          setvalidarHoraInicial('')
          setvalidarHoraFinal('')
        }
      }

      const handleOnchangeHoraFinal=(e)=>{
        sethoraF(e.target.value)
        if(e.target.value === ""){
          setvalidarHoraFinal('Seleccionar Hora Final')          
        }else if(e.target.value === horaI){
          setvalidarHoraFinal('Hora inicial y Hora final no pueden ser iguales')
          setvalidarHoraInicial('Hora inicial y Hora final no pueden ser iguales')
        }else if(e.target.value < horaI){
          setvalidarHoraFinal('Hora Final no puede ser menor a la hora Inicial')
          setvalidarHoraInicial('')
        }else if(horaI > e.target.value){
          setvalidarHoraFinal('')
          setvalidarHoraInicial('Hora Inicial no puede ser mayor a la hora Final')
        }        
        else{
          setvalidarHoraFinal('')
          setvalidarHoraInicial('')
        }
      }

      const handleOnchangeFecha=(e)=>{
        if(e.target.value !== ""){
          setvalidarFecha('')
        }else{
          setvalidarFecha('Seleccionar Fecha')
        }
      }

      const quirofanosCirugia=()=>{
        setmodalOnQuirofanos(true)
      }
      
      const passDataQuirofano=(data)=>{
        //console.log(data,'dataaa')
        setmodalOnQuirofanos(false)
        setdataQuirofano({
          codigoQuirofano:data.codigoQuirofano,
          descripcionQuirofano:data.descripcionQuirofano, 
        })
      }

      // useEffect(()=>{
        
      //   function isDateTimeRangeOverlapping(userStartDateTime, userEndDateTime, existingStartDateTime, existingEndDateTime) {
      //     // Convertir las cadenas de fecha y hora a objetos Date
      //     const userStart = new Date(userStartDateTime);
      //     const userEnd = new Date(userEndDateTime);
      //     const existingStart = new Date(existingStartDateTime);
      //     const existingEnd = new Date(existingEndDateTime);

          
        
      //     // Calcular el punto medio del intervalo del usuario
      //     const userMidTime = new Date((userStart.getTime() + userEnd.getTime()) / 2);
        
      //     // Verificar si el punto medio del intervalo del usuario cae dentro del intervalo existente
      //     if (userMidTime >= existingStart && userMidTime <= existingEnd) {
      //       return true; // El punto medio cae dentro del intervalo existente, por lo tanto, hay solapamiento
      //     }
        
      //     // Verificar si algún otro punto del intervalo del usuario se solapa con el intervalo existente
      //     if ((userStart >= existingStart && userStart <= existingEnd) ||
      //         (userEnd >= existingStart && userEnd <= existingEnd) ||
      //         (existingStart >= userStart && existingStart <= userEnd) ||
      //         (existingEnd >= userStart && existingEnd <= userEnd)) {
      //       return true; // Alguna parte del intervalo del usuario se solapa con el intervalo existente
      //     }
        
      //     // Si ninguna condición se cumple, entonces no hay solapamiento
      //     return false;
      //   }
        
      //   // Ejemplo de uso con fechas y horas
      //   const existingStartDateTime = '2024-03-02 08:10';
      //   const existingEndDateTime = '2024-03-02 23:00';
        
      //   // Intervalo ingresado por el usuario
      //   const userStartDateTime = '2024-03-03 08:00';
      //   const userEndDateTime = '2024-03-03 08:10';
        
      //   // Verificar si hay solapamiento
      //   const isOverlapping = isDateTimeRangeOverlapping(userStartDateTime, userEndDateTime, existingStartDateTime, existingEndDateTime);
        
      //   console.log(isOverlapping ? 'Ocupado' : 'Libre');
        
        


      // },[])
      
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
        <div className="flex-grow text-center">
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     RESERVA
    </h5>
  </div>
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
        <form onSubmit={handleSubmitReprogramacion}>
          <div className="flex-auto overflow-y-auto relative p-1">
            
              
              <div className="flex flex-row py-2  text-left">
                {/* <div className="w-1/4  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Empresa 
                  </label>
                  <input
                   defaultValue={user.ProEmpCod}
                    //autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.ProCirCod}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div> */}
                {/* <div className="w-1/4  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Sede
                  </label>
                  <input
                  defaultValue={user.ProMCDpto}
                    autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.MPCedu}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div> */}
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Paciente
                  </label>
                  <input
                  defaultValue={user.MPNOMC}
                  name='pacienteCedula'
                    autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.MPNOMC}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    N° Cirugía
                  </label>
                  <input
                  defaultValue={user.ProCirCod}
                    autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.MPTDoc}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Quirófano
                  </label>
                  <input
                  defaultValue={user.ConsDet}
                    autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.MPNOMC}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
              <div className="flex flex-row py-2  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Fecha Cirugía
                  </label>
                  <input
                    defaultValue={user.ProFec.split(' ')[0]}
                    autoComplete="off"
                    type="date"
                    disabled={true}
                    //defaultValue={dataUser.ProCirCod}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Hora Inicial
                  </label>
                  <input
                  defaultValue={user.ProHorI}
                    autoComplete="off"
                    type="time"
                    disabled={true}
                    //defaultValue={dataUser.MPCedu}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Hora Final
                  </label>
                  <input
                    defaultValue={user.ProHorF}
                    autoComplete="off"
                    type="time"
                    disabled={true}
                    //defaultValue={dataUser.MPTDoc}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                
              </div>
              
              <div className="bg-[#05a29d] mt-3">
            <h5
              className="text-xl font-medium leading-normal text-white text-center "
              id="exampleModalScrollableLabel"
            >
              REPROGRAMACIÓN
            </h5>
            </div>
            <div className="flex flex-row py-2  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Fecha Cirugía
                  </label>
                  <input
                    // defaultValue={user.ProFec.split(' ')[0]}
                    autoComplete="off"
                    type="date"
                    // disabled={true}
                    //defaultValue={dataUser.ProCirCod}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='fechaCirugia'
                    onChange={handleOnchangeFecha}
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {validarFecha}
                  </label>
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Hora Inicial
                  </label>
                  <input
                  // defaultValue={user.ProHorI}
                    autoComplete="off"
                    type="time"
                    // disabled={true}
                    //defaultValue={dataUser.MPCedu}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='horaInicial'
                    onChange={handleOnchangeHoraInicial}
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {validarHoraInicial}
                  </label>
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Hora Final
                  </label>
                  <input
                    // defaultValue={user.ProHorF}
                    autoComplete="off"
                    type="time"
                    // disabled={true}
                    //defaultValue={dataUser.MPTDoc}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='horaFinal'
                    onChange={handleOnchangeHoraFinal}
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {validarHoraFinal}
                  </label>
                </div>
                
              </div>
              <div className="flex flex-row py-2  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Código Quirófano
                  </label>
                  <input
                    onFocus={quirofanosCirugia}
                    value={dataQuirofano.codigoQuirofano}
                    //autoComplete="text"
                    type="text"                                       
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  
                </div>
                <div className="w-2/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Descripción Quirófano
                  </label>
                  <input
                  value={dataQuirofano.descripcionQuirofano}
                    // autoComplete="off"
                    type="text"
                    disabled={true}
                    //defaultValue={dataUser.MPCedu}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                
                
              </div>
            <div className="text-left pt-1">
              <div className="w-1/4  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Seleccionar el motivo
                </label>
                <div className="">
                  <select
                    //defaultValue={dataDetalles.ViaCod}
                    onChange={handleOnchange}
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='idMotivo'
                  >
                    <option value="Sin Motivo">Sin Motivo</option>
                    <option value="1">Administrativo </option>
                    <option value="2">Paciente</option>
                    <option value="3">Médico</option>
                  </select>
                </div>
                
              </div>
              <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorMotivoReprogramacion}
                </label>
              <div className=" px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Motivo Reprogramación
                  </label>
                <textarea
                  autoComplete="off" 
                  defaultValue={textAreaMotivo} 
                  name='stringMotivo'                    
                  className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlTextarea1"
                  rows="2"
                  placeholder=""
                ></textarea>
              </div>
            </div>

            
          </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Reprogramar
          </button>
        </div>
        </form>
        </div>
      </div>
    </div>
    {modalOnQuirofanos? <ModalQuirofanosReprogramar setmodalOnQuirofanos={setmodalOnQuirofanos} passDataQuirofano={passDataQuirofano}/>:null}
    {modalOnOcupadoQuirofano? <ModalValidarQuirofanosReprogramacion setmodalOnOcupadoQuirofano={setmodalOnOcupadoQuirofano} textQuirofanoOcupado={textQuirofanoOcupado}/>:null}
  </div>
  )
}

export default CambioDeEstadoReProgramacion